import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { BsHourglassSplit } from "react-icons/bs";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import {Box, keyframes} from '@mui/material';

function MyTimer({ expiryTimestamp, isSmallScreen, t }) {
    const calculateTimeLeft = () => {
        const difference = new Date(expiryTimestamp) - new Date();
        if (difference > 0) {
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / 1000 / 60) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            return { hours, minutes, seconds, completed: false };
        } else {
            return { hours: 0, minutes: 0, seconds: 0, completed: true };
        }
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [expiryTimestamp]);

    const bounce = keyframes`
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-3px);
        }
    `;

    return (
        <Tooltip title={t("estimated_time")}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    borderRadius: 1,
                    padding: "6px 12px",
                    fontSize: "0.75rem",
                    fontWeight: "medium",
                    ml: { xs: 0, sm: 1 },
                }}
            >
                <Box
                    sx={{
                        fontSize: "14px",
                        animation: `${bounce} 1.5s ease-in-out infinite`,
                        display: "flex",
                    }}
                >
                    <BsHourglassSplit />
                </Box>
                {!timeLeft.completed ? (
                    <>
                        <Typography variant="caption" sx={{ color: "white", fontSize: "0.75rem" }}>
                            ~
                        </Typography>
                        <Typography sx={{ color: "white", fontSize: "0.75rem" }}>
                            {String(timeLeft.hours).padStart(2, "0")}:
                            {String(timeLeft.minutes).padStart(2, "0")}:
                            {String(timeLeft.seconds).padStart(2, "0")}
                        </Typography>
                    </>
                ) : (
                    <Typography sx={{ color: "white", fontSize: "0.75rem" }}>
                        {t("processing_wait")}
                    </Typography>
                )}
            </Box>
        </Tooltip>
    );
}

MyTimer.propTypes = {
    expiryTimestamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]).isRequired,
    isSmallScreen: PropTypes.bool,
    t: PropTypes.func
};

export default MyTimer;
